import { format } from 'date-fns';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { Site } from '@swf/core/enums';
import useTimer from '@swf/core/hooks/useTimer';
import { select } from '@swf/core/store';

import styles from './MachineDate.scss';

const timeUpdater = (time: number) => time + 1000;

const MachineDate = () => {
  const startTime = useRef(Date.now());
  const date = useTimer({ modifier: timeUpdater, initial: startTime.current });
  const site = useSelector(select.site.getId);
  const dateFormat = site === Site.CZ ? 'dd/MM/yyyy HH:mm:ss' : 'MM/dd/yyyy HH:mm:ss';

  return (
    <div className={styles.date}>
      <span className={styles.dateContent}>{format(date, dateFormat)}</span>
    </div>
  );
};

export default MachineDate;
